import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class StripeCustomerAddress extends BaseEntityModel {
  public line1?: string;

  public line2?: string;

  public city?: string;

  public state?: string;

  public postalCode?: string;

  public country?: string;

  constructor(model: Partial<StripeCustomerAddress> = {}) {
    super(model);

    this.line1 = model.line1 as string;
    this.line2 = model.line2 as string;
    this.city = model.city as string;
    this.state = model.state as string;
    this.postalCode = model.postalCode as string;
    this.country = model.country as string;
  }

  get formattedAddress(): string {
    return [this.line1, this.line2, this.city, this.state, this.postalCode, this.country]
      .filter(Boolean)
      .join(', ');
  }
}
